"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisuallyHidden = void 0;
const utils_1 = require("@mui/utils");
const react_1 = require("react");
const VisuallyHidden = ({ id, component, text }) => ((0, react_1.createElement)(component ?? 'span', {
    id,
    style: utils_1.visuallyHidden,
    children: [text],
}));
exports.VisuallyHidden = VisuallyHidden;
//# sourceMappingURL=visually-hidden.js.map